import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as PopupActions from '../../actions/popup';
import { connect } from 'react-redux';
import appStoreImg from '../../assets/images/app-store.png';
import googlePlayImg from '../../assets/images/google-play.png';
import { links } from '../../constants/links';
import { showAppLegacyCompanyId } from '../../utils/utils';
import { getCountryLabel } from '../../helpers/components';
import { messagesSelector, registerCountriesSelector } from '../../helpers/selectors';

// One row per platform: the store links (legacy app vs current app) and the
// badge asset. `appType` values match these keys.
const STORE_LINKS = {
  ios: {
    legacy: links.legacyAppLinkApple,
    current: links.appStoreLink,
    img: appStoreImg,
    alt: 'App Store'
  },
  android: {
    legacy: links.legacyAppLinkPlay,
    current: links.playStoreLink,
    img: googlePlayImg,
    alt: 'Google Play'
  }
};

function getStoreLink(platform, companyId) {
  const { legacy, current } = STORE_LINKS[platform];

  return showAppLegacyCompanyId(companyId) ? legacy : current;
}

class MobileAppSelectorPopup extends Component {
  constructor(props) {
    super(props);
    this.state = { storeLinksCompanyId: null };
    this.bindFunctions();
  }

  bindFunctions() {
    this.pickCountryToRedirect = this.pickCountryToRedirect.bind(this);
  }

  getFlags() {
    const { registerCountries, m } = this.props;

    return registerCountries.map((country) => {
      const { iso, companyId, iconUrl } = country;

      return (
        <li onClick={() => this.pickCountryToRedirect(companyId)} key={iso}>
          <i style={{ backgroundImage: `url(${iconUrl})` }} />
          <span>{getCountryLabel(m, country)}</span>
        </li>
      );
    });
  }

  pickCountryToRedirect(companyId) {
    const { popup_MobileAppSelector_SetVisibility, appType } = this.props;

    // Opened without a platform (e.g. the Renault-France detour): the visitor's
    // device is unknown, so offer both store badges instead of guessing.
    if (!appType) {
      this.setState({ storeLinksCompanyId: companyId });
      return;
    }

    window.open(getStoreLink(appType, companyId), '_blank');
    popup_MobileAppSelector_SetVisibility(false);
  }

  renderStoreLinks(companyId) {
    return (
      <div className="text-center store-links mt-40 mb-35">
        {Object.entries(STORE_LINKS).map(([platform, { img, alt }]) => (
          <a
            key={platform}
            href={getStoreLink(platform, companyId)}
            target="_blank"
            rel="noreferrer"
          >
            <img src={img} alt={alt} className="m-5 va-top" />
          </a>
        ))}
      </div>
    );
  }

  render() {
    // A company known up front (the Renault-France checkpoint hands one in)
    // skips the country picker straight to its store links; a flag click sets
    // the same id at runtime for the picker-less banner/guard entry points.
    const companyId = this.state.storeLinksCompanyId || this.props.preselectedCompanyId;

    if (companyId) {
      return (
        <div className="mobile-app-selector-popup">{this.renderStoreLinks(companyId)}</div>
      );
    }

    const flags = this.getFlags();

    if (flags.length === 0) {
      return (
        <div className="mobile-app-selector-popup">
          <div className="text-center f-25 mt-40 mb-10">
            <FormattedMessage id="no_apps_available" />
          </div>
        </div>
      );
    }

    return (
      <div className="mobile-app-selector-popup">
        <div className="text-center f-25 mt-40 mb-10">
          <FormattedMessage id="select.country.for.app.deeplinks" />
        </div>
        <div className="text-center mb-35">
          <ul className="flag-country-selector">{flags}</ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    registerCountries: registerCountriesSelector(state),
    m: messagesSelector(state),
    appType: state.popup?.mobileAppSelectorType,
    preselectedCompanyId: state.popup?.mobileAppSelectorCompanyId
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...PopupActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppSelectorPopup);
